<template>
  <div class="ant-skeleton ant-skeleton-active">
    <div class="ant-skeleton-content">
      <h3 class="ant-skeleton-title" style="width: 38%;"></h3>
      <ul class="ant-skeleton-paragraph">
        <li></li>
        <li></li>
        <li style="width: 61%;"></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Skeleton'
}
</script>

<style scoped>
.ant-skeleton.ant-skeleton-active .ant-skeleton-content .ant-skeleton-title, .ant-skeleton.ant-skeleton-active .ant-skeleton-content .ant-skeleton-paragraph>li{
  background: linear-gradient(90deg,rgba(190,190,190,.2) 25%,rgba(129,129,129,.24) 37%,rgba(190,190,190,.2) 63%);
  background-size: 400% 100%;
  -webkit-animation: ant-skeleton-loading 1.4s ease infinite;
  animation: ant-skeleton-loading 1.4s ease infinite;
}
.ant-skeleton-content .ant-skeleton-title {
  width: 100%;
  height: 16px;
  margin-top: 16px;
  background: rgba(190,190,190,.2);
  border-radius: 4px;
}

.ant-skeleton-paragraph > li{
  margin: 3px 0;
}

.ant-skeleton-content .ant-skeleton-title+.ant-skeleton-paragraph {
  margin-top: 24px;
}
.ant-skeleton-content .ant-skeleton-paragraph {
  padding: 0;
}
.ant-skeleton-content .ant-skeleton-paragraph>li {
  width: 100%;
  height: 16px;
  list-style: none;
  background: rgba(190,190,190,.2);
  border-radius: 4px;
}

@-webkit-keyframes ant-skeleton-loading{0%{background-position:100% 50%}to{background-position:0 50%}}
</style>



// WEBPACK FOOTER //
// src/components/Utilities/Skeleton.vue